export const permissions = {
    permissions: ['REALIZE_HOME_MODULE_VIEWER'],
};
